import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center px-6 md:px-12 overflow-hidden bg-navy" data-id="element-46">
      {/* Faint compass mark in background corner */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 opacity-[0.04] pointer-events-none" data-id="element-47">
        <Compass className="w-[700px] h-[700px] text-cream" strokeWidth={0.5} data-id="element-48" />
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10 mt-20" data-id="element-49">
        <FadeIn delay={0.2} data-id="element-50">
          <div className="flex items-center space-x-4 mb-10" data-id="element-51">
            <div className="w-10 h-[1px] bg-gold" data-id="element-52"></div>
            <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-gold" data-id="element-53">
              Wyoming · Estados Unidos · Fundada en 2025
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.35} data-id="element-54">
          <h1 className="font-display text-7xl md:text-9xl lg:text-[11rem] text-cream leading-[0.85] tracking-tighter mb-10" data-id="element-55">
            BPF LLC
          </h1>
        </FadeIn>

        <FadeIn delay={0.55} data-id="element-56">
          <div className="max-w-3xl" data-id="element-57">
            <p className="text-xl md:text-2xl text-cream/90 font-light leading-relaxed mb-6" data-id="element-58">
              Democratizamos el conocimiento a través de libros digitales
              accesibles para todo el mundo.
            </p>
            <p className="text-base md:text-lg text-muted font-light leading-relaxed" data-id="element-59">
              Una compañía 100% online dedicada a la edición y distribución de
              libros digitales, especialistas en el armado de funnels Low Ticket
              a través de Meta Ads.
            </p>
          </div>
        </FadeIn>
      </div>

      
    </section>;
}